import React from 'react';
import { currencyFormat } from 'utils/Funciones';

const PriceTag = ({ price, tipo, stock }) => {
    const stockColor =
        stock === 0
            ? 'bg-gradient-to-r from-red-500 to-red-600 dark:from-red-600 dark:to-red-700'
            : stock <= 3
                ? 'bg-gradient-to-r from-amber-400 to-amber-500 dark:from-amber-500 dark:to-amber-600'
                : 'bg-gradient-to-r from-green-400 to-green-500 dark:from-green-500 dark:to-green-600';

    const stockStatus = stock === 0 ? 'Sin stock' : `Stock: ${stock}`;

    return (
        <div className="flex justify-between items-center mt-4">
            <div className="font-normal text-xl text-gray-900 dark:text-gray-100">
                {currencyFormat(price)}
            </div>
            <div>
                {tipo === 'servicio' ? (
                    <span className="text-sm font-bold bg-brand-500 dark:bg-brand-400 text-white py-1 px-3 rounded-xl">
                        Servicio
                    </span>
                ) : (
                    <span className={`text-sm font-bold ${stockColor} text-white py-1 px-3 rounded-xl`}>
                        {stockStatus}
                    </span>
                )}
            </div>
        </div>
    );
};

export default PriceTag;
